import {
  isAndroid,
  isDesktopBrowser,
  isiOS,
  isMobileBrowser,
  isMobileEmbedded,
  isTabletBrowser,
} from '@rover/rsdk/src/modules/Network/userAgent';
import type { UserAgentFlags } from '@rover/types';

export default (): UserAgentFlags => {
  // Check whether these functions exist (e.g. `isDesktopBrowser &&`) because treeshaking may remove them.
  return {
    isDesktop: isDesktopBrowser && isDesktopBrowser(navigator.userAgent),
    isEmbedded: isMobileEmbedded && isMobileEmbedded(),
    isMobile: isMobileBrowser && isMobileBrowser(navigator.userAgent),
    isTablet: isTabletBrowser && isTabletBrowser(navigator.userAgent),
    isAndroid: isAndroid && isAndroid(navigator.userAgent),
    isiOS: isiOS && isiOS(navigator.userAgent),
  };
};
